import R from 'ramda';
import moment from 'moment';

import questionnairetpl from './questionnaire.tpl.html';
import { getCompanyById } from '../../../../reducers/companies';
import { getQuestionnaireById, getLoading } from '../../../../reducers/questionnaires';
import utils from '../../../../services/utils';

export class Questionnaire {
  constructor(
    $scope,
    $ngRedux,
    actionsFactory,
    $translate,
    $location,
    $anchorScroll,
    companiesService) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
      $location,
      $anchorScroll,
      companiesService,
    });
    const unsubscribe = $ngRedux.connect(Questionnaire.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
    this.roundPercentage = Questionnaire.roundPercentage;
    this.roundToSigDigits = Questionnaire.roundToSigDigits;

    this.scoreLegend = [
      { min: 0, max: 20, label: `C - ${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_CRITICAL')}` },
      { min: 21, max: 30, label: `CC - ${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_WEAK')}` },
      { min: 31, max: 40, label: `CCC - ${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_WEAK')}` },
      { min: 41, max: 50, label: `B - ${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_FAIR')}` },
      { min: 51, max: 60, label: `BB - ${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_FAIR')}` },
      { min: 61, max: 70, label: `BBB - ${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_FAIR')}` },
      { min: 71, max: 80, label: `A - ${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_GOOD')}` },
      { min: 81, max: 90, label: `AA - ${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_GOOD')}` },
      { min: 91, max: 100, label: `AAA - ${this.$translate.instant('SCORE_LEGEND_DESCRIPTION_EXCELLENT')}` },
    ];

    this.scoreLegendContent = undefined;
  }

  static mapStateToThis(state) {
    return {
      auth: state.authentication,
      router: state.router,
      company: getCompanyById(state, state.router.currentParams.id),
      questionnaire: getQuestionnaireById(state, state.router.currentParams.questionnaireId),
      loading: getLoading(state),
    };
  }

  $onInit() {
    this.reqQuestionnaireStart(
      this.router.currentParams.id,
      this.router.currentParams.questionnaireId);

    this.isEditor = utils.isLoggedInUserOfType(this.auth.user.type, ['editor']);
    this.showModalDraftQuestionnaire = false;

    this.questionnaireButtons = {
      isEditorWithReviewingQuestionnaire: [
        {
          onClick: 'rejectQuestionnaire',
          name: 'QUESTIONNAIRE_REJECT',
          className: 'tct-questionnaire__partialsave tct__button tct__button-secondary',
        },
        {
          onClick: 'approveQuestionnaire',
          name: 'QUESTIONNAIRE_APPROVE',
          className: 'tct-questionnaire__partialsave tct__button tct__button-gradient',
        },
      ],
      isContactUserWithDraftOrRejectedQuestionnaire: [
        {
          onClick: 'partialSave',
          name: 'GENERIC_PARTIALSEND',
          className: 'tct-questionnaire__partialsave tct__button tct__button-secondary',
        },
        {
          onClick: 'sendQuestionnaire',
          name: 'GENERIC_SEND',
          className: 'tct-questionnaire__partialsave tct__button tct__button-gradient',
        },
      ],
      isEditorWithReviewingQuestionnaireOfEditedOrder: [
        {
          onClick: 'openModalDraftQuestionnaire',
          name: 'SET_QUESTIONNAIRE_TO_DRAFT',
          className: 'tct-questionnaire__partialsave tct__button tct__button-secondary',
        },
        {
          onClick: 'approveQuestionnaire',
          name: 'QUESTIONNAIRE_APPROVE',
          className: 'tct-questionnaire__partialsave tct__button tct__button-gradient',
        },
      ],
    };
  }

  scrollTo(hash) {
    this.$location.hash(hash).replace();
    this.$anchorScroll();
  }

  uploadFile(event) {
    this.uploadFileQuestionnaireStart(
      event.target.files[0],
      event.target.dataset,
      this.router.currentParams.questionnaireId,
    );
  }

  deleteFile(data) {
    this.deleteFileQuestionnaireStart(data, this.router.currentParams.questionnaireId);
  }

  /* eslint-disable */

  mapContent() {
    const groups = R.map(group => Object.assign({}, group, {
      fields: R.map(row => R.values(row).filter(field => typeof field === 'object'), group.fields)
    }), R.values(this.questionnaire.groups));
    const mappedGroups = groups.map((group) => {
      group.fields.map((field) => {
        return field.map((item) => {
          if (item.date) {
            item.value = this.formatDate(item.date);
          } else if (typeof item.value === 'undefined') {
            item.value = null;
          }
          return item;
        });
      });
      return group;
    });

    const fields = R.values(this.questionnaire.fields);
    const mappedFields = fields.map((field) => {
      if (field.date) {
        field.value = this.formatDate(field.date);
      } else if (typeof field.value === 'undefined') {
        field.value = null;
      }
      return field;
    });

    return R.concat(mappedFields, mappedGroups);
  }

  saveEditableField(section, text) {
    this.questionnaire.notes = {};
    this.questionnaire.notes = {
        section_id: section,
        value: text
    };
    this.updateQuestionnaireStart(
      this.router.currentParams.questionnaireId,
      this.mapContent(),
      this.questionnaire.score,
      this.questionnaire.notes);
  }

  partialSave() {
    this.updateQuestionnaireStart(
      this.router.currentParams.questionnaireId,
      this.mapContent(),
      this.questionnaire.score,
      this.questionnaire.notes);
  }

  getLegendForScore() {
    if (!this.scoreLegendContent) {
      const rows = this.scoreLegend
        .map(legend => `<tr><td><strong>${legend.label}<strong></td><td>${legend.min}</td><td>${legend.max}</td></tr>`)
        .join('');
      const legendTitle = this.$translate.instant('SCORE_LEGEND_TITLE');
      this.scoreLegendContent = `<h1 class="score-legend-title">${legendTitle}</h1><table class="score-legend-table">${rows}</table>`;
    }

    return this.scoreLegendContent;
  }

  sendQuestionnaire() {
    this.sendQuestionnaireStart(
      this.router.currentParams.questionnaireId,
      this.mapContent());
  }

  onSelect2Change(item, model, binding) {
    binding.readOnlyValue = item.name;
  }

  toggleMultipleField(field, id) {
    let choices;
    if (Array.isArray(field.value)) {
      choices = field.value;
    } else {
      choices = [];
    }
    let idx = choices.indexOf(id);

    // Is currently selected
    if (idx > -1) {
      choices.splice(idx, 1);
    } else {
      choices.push(id);
    }

    field.value = choices;
  }

  getReadOnlyValueForSelectWithChoices(selected, choices) {
    return R.propOr(this.$translate.instant('GENERIC_EMPTY_VALUE'), 'text', R.head(
      R.filter(R.propEq('id', Number(selected)), choices)));
  }


  addGroup(item) {
    const newGroup = R.indexBy(R.prop('id'),
      R.map(field => ({ id: field.id, type: field.type, name: field.name, value: null }), item.fields));
    this.questionnaire.groups[item.id].fields.push(newGroup);
  }

  duplicateGroupOnTheNextSection(itemIndex, item, nextSectionItem, groups) {
    const newGroup = R.indexBy(R.prop('id'),
      R.map(field => ({ id: field.id, type: field.type, name: field.name, value: null }), nextSectionItem.fields));

    angular.forEach(groups[itemIndex], function(value1) {
      if (typeof value1.name !== 'undefined') {
        angular.forEach(newGroup, function(value2, key) {
          if(value1.name === value2.name) {
            newGroup[key].value = value1.value;
          }
        });
      }
    });

    const newId = item.id + 1;
    this.questionnaire.groups[newId].fields.push(newGroup);
  }

  isReadOnly() {
    const check = this.questionnaire &&
      this.questionnaire &&
      this.questionnaire.contactUser;

    if (check) {
      return (
        this.questionnaire.status === 'approved' ||
        (!this.isEditor && R.contains(
          this.questionnaire.status, ['reviewing'])) ||
        (this.isEditor && R.contains(
          this.questionnaire.status, ['rejected', 'reviewing', 'draft'])));
    }

    return false;
  }

  canAssignScores() {
    const check = this.questionnaire &&
      this.questionnaire &&
      this.questionnaire.contactUser;

    if (check) {
      return (
        (this.isEditor && R.contains(
          this.questionnaire.status, ['reviewing'])));
    }

    return false;
  }

  isReadOnlyAndEditor() {
    return this.isReadOnly() || this.isEditor;
  }

  isApproved() {
    const check = this.questionnaire &&
      this.questionnaire &&
      this.questionnaire.contactUser;

    if (check) {
      return this.questionnaire.status === 'approved';
    }

    return false;
  }

  isQuestionnaireType(type, check) {
    if (typeof type !== 'undefined' && typeof check !== 'undefined') {
      if (type.indexOf(check) >= 0) {
        return true;
      }

    }
    return false;
  }

  viewQuestionnaireComment() {
    const check = this.questionnaire &&
      this.questionnaire &&
      this.questionnaire.status;
    if (check) {
      return (
        this.questionnaire.orderStatus === 'completed' ||
        this.questionnaire.status === 'approved' ||
        (this.isEditor && R.contains(
          this.questionnaire.status, ['reviewing'])));
    }

    return false;
  }

  readOnlyQuestionnaireComment() {
    const check = this.questionnaire &&
      this.questionnaire &&
      this.questionnaire.status;

    if (check) {
      return (
        this.questionnaire.status === 'approved');
    }

    return false;
  }

  removeGroup() {
    this.questionnaire.groups[this.modalItem.item.id]
      .fields.splice(this.modalItem.index, 1);
    this.showConfirmationModal = false;
  }

  disableRemove(item) {
    return this.questionnaire.groups[item.id].fields.length === 1;
  }

  doShowConfirmationModal(item, group, index) {
    this.modalItem = {
      item,
      group,
      index,
    };
    this.showConfirmationModal = true;
  }

  hideConfirmationModal() {
    this.modalItem = {};
    this.showConfirmationModal = false;
  }

  viewQuestionnaireButtons() {
    const check = this.questionnaire && this.questionnaire.status;

    if (check) {
      if (!this.questionnaire.contactUser || (typeof this.questionnaire.contactUser === 'object' && !this.questionnaire.contactUser.hasOwnProperty('id'))) {
        return false;
      }

      if (this.questionnaire.status === 'reviewing' && this.auth.user.type === 'editor' && this.questionnaire.orderStatus !== 'editing') {
        return 'isEditorWithReviewingQuestionnaire';
      }

      if (this.questionnaire.status === 'reviewing' && this.auth.user.type === 'editor' && this.questionnaire.orderStatus === 'editing') {
        return 'isEditorWithReviewingQuestionnaireOfEditedOrder';
      }

      if ((this.questionnaire.status === 'draft' || this.questionnaire.status === 'rejected') &&
        this.auth.user.id === this.questionnaire.contactUser.id) {
        return 'isContactUserWithDraftOrRejectedQuestionnaire';
      }

      if (this.questionnaire.status === 'approved' || this.questionnaire.status === 'empty') {
        return false;
      }
    }

    return false;
  }

  rejectQuestionnaire() {
    this.rejectQuestionnaireStart(this.router.currentParams.questionnaireId);
  }

  approveQuestionnaire() {
    this.approveQuestionnaireStart(this.router.currentParams.questionnaireId,
      this.mapContent(),
      this.questionnaire.manualScores);
  }

  getFinalScore() {
    if (!this.questionnaire || !this.questionnaire.template || !this.questionnaire.template.manualScores) {
      return undefined;
    }

    const score = R.values(this.questionnaire.template.manualScores)
      .map(manualScore =>
      (manualScore.scoreName == 'hq_risk' || manualScore.scoreName == 'country_risk')
        ? (100 - (this.questionnaire.manualScores[manualScore.id].score || 0)) * (manualScore.weight || 0)
        : (this.questionnaire.manualScores[manualScore.id].score || 0) * (manualScore.weight || 0)
      )
      .reduce((finalScore, partialScore) => finalScore + partialScore, this.questionnaire.previewScore || 0);
    return Math.round(score * 100) / 100;
  }

  getPlaceholderForItem(item) {
    const placeholder = item.subtype == 'textarea'
      ? 'QUESTIONNAIRE_ITEM_TEXTAREA_PLACEHOLDER'
      : 'QUESTIONNAIRE_ITEM_INPUT_GENERIC_PLACEHOLDER'
    return item && item.name && item.subtype != 'textarea'
      ? this.$translate.instant('QUESTIONNAIRE_ITEM_INPUT_PLACEHOLDER', { fieldName: item.name.toLocaleLowerCase() })
      : this.$translate.instant(placeholder);
  }

  formatDate(date) {
    return moment(date).format('DD-MM-YYYY').replace(/-/g, '/');
  }

  static byId(acc, field) {
    acc[field.id] = {};
    acc[field.id].type = field.type;
    acc[field.id].id = field.id;
    acc[field.id].value = '';
    return acc;
  }

  static byFieldsToKeep(ids, element) {
    return element.type === 'group' || R.contains(element.id, ids);
  }

  static toPlainGroups(group) {
    const mappedGroup = R.clone(group);
    mappedGroup.fields = R.map(Questionnaire.filteredValues, mappedGroup.fields);
    return mappedGroup;
  }

  static filteredValues(field) {
    return R.filter(validFieldItems, R.values(field));
    function validFieldItems(item) {
      return typeof item === 'object';
    }
  }

  static roundPercentage(value) {
    return Math.round(value * 100);
  }

  static roundToSigDigits(value, digits = 2) {
    const rounder = Math.pow(10, digits);
    return Math.round((value || 0) * rounder) / rounder;
  }

  openModalDraftQuestionnaire(questionnaireId) {
    this.showModalDraftQuestionnaire = true;
  }

  closeModalDraftQuestionnaire() {
    this.showModalDraftQuestionnaire = false;
    this.message = null;
  }

  setQuestionnaireToDraft() {
    this.setQuestionnaireToDraftStart(this.router.currentParams.questionnaireId, this.message);
    this.showModalDraftQuestionnaire = false;
    this.message = null;
  }
}

Questionnaire.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
  '$location',
  '$anchorScroll',
  'companiesService',
];

export const questionnaire = {
  template: questionnairetpl,
  controller: Questionnaire,
};
